// Phase 74 — `/my-360` is a Player/Parent convenience alias that redirects
// to the canonical `/athlete/:athleteId/360` route. The linked athlete id is
// resolved from `/api/auth/me` (single source of truth) so the redirect
// stays in sync with any backend re-linking and doesn't depend on the
// AuthContext's cached user payload.
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const API = process.env.REACT_APP_BACKEND_URL;

export default function My360Redirect() {
  const { user } = useAuth();
  const [resolvedAthleteId, setResolvedAthleteId] = useState(undefined);

  useEffect(() => {
    let cancelled = false;
    const fromContext = user?.athlete_id || (user?.assigned_athletes || [])[0];
    (async () => {
      try {
        const res = await axios.get(`${API}/api/auth/me`);
        if (cancelled) return;
        const fresh = res.data?.athlete_id || (res.data?.assigned_athletes || [])[0] || fromContext;
        setResolvedAthleteId(fresh || null);
      } catch {
        if (!cancelled) setResolvedAthleteId(fromContext || null);
      }
    })();
    return () => { cancelled = true; };
  }, [user]);

  if (resolvedAthleteId === undefined) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center text-gray-500" data-testid="my-360-loading">
        <Loader2 className="h-5 w-5 animate-spin" />
      </div>
    );
  }
  if (!resolvedAthleteId) {
    return (
      <div className="flex min-h-[60vh] flex-col items-center justify-center text-gray-500" data-testid="my-360-no-link">
        <p className="text-sm">Your account is not linked to an athlete yet.</p>
      </div>
    );
  }
  return <Navigate to={`/athlete/${resolvedAthleteId}/360`} replace />;
}
